(function () {
  "use strict";
  if (window.__pbxInit) return;
  window.__pbxInit = true;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- wishlist: persisted in localStorage, works everywhere ---------------- */
  var WISH_KEY = "pbx_wishlist";
  function pbxGetWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function pbxSetWishlist(arr) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function pbxIsWished(id) {
    return pbxGetWishlist().indexOf(String(id)) !== -1;
  }
  function pbxToggleWishlist(id) {
    id = String(id);
    var list = pbxGetWishlist();
    var i = list.indexOf(id);
    if (i === -1) list.unshift(id); else list.splice(i, 1);
    pbxSetWishlist(list);
    pbxUpdateWishCount();
    return pbxIsWished(id);
  }
  function pbxUpdateWishCount() {
    var n = pbxGetWishlist().length;
    document.querySelectorAll(".pbx-wish-count").forEach(function (el) { el.textContent = String(n); });
  }
  function pbxSyncWishEl(el) {
    var id = el.dataset.wishId;
    if (!id) return;
    var on = pbxIsWished(id);
    if (el.classList.contains("pbx-wish")) el.classList.toggle("is-active", on);
    el.setAttribute("aria-pressed", String(on));
  }
  function pbxBindWishEl(el) {
    if (el.dataset.wishBound) { pbxSyncWishEl(el); return; }
    el.dataset.wishBound = "1";
    pbxSyncWishEl(el);
    el.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      pbxToggleWishlist(el.dataset.wishId);
      document.querySelectorAll('[data-wish-id="' + el.dataset.wishId + '"]').forEach(pbxSyncWishEl);
    });
  }
  window.PBX_WISHLIST = {
    get: pbxGetWishlist,
    isWished: pbxIsWished,
    toggle: pbxToggleWishlist,
  };
  function pbxInitWishlist(root) {
    (root || document).querySelectorAll("[data-wish-id]").forEach(pbxBindWishEl);
    pbxUpdateWishCount();
  }

  /* ---------------- rails ---------------- */
  function syncRail(rail) {
    var name = rail.dataset.railName;
    var btns = document.querySelectorAll('[data-rail-target="' + name + '"]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    btns.forEach(function (b) {
      b.disabled = Number(b.dataset.railDir) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
    });
  }
  function initRails() {
    document.querySelectorAll('.pbx-rail[data-rail-name]').forEach(function (rail) {
      if (rail.__pbxRailInit) return;
      rail.__pbxRailInit = true;
      var name = rail.dataset.railName;
      document.querySelectorAll('[data-rail-target="' + name + '"]').forEach(function (b) {
        b.addEventListener('click', function () {
          var first = rail.querySelector('.pbx-pcard, .pbx-kit-card, .pbx-fam');
          var step = first ? first.getBoundingClientRect().width + 20 : 320;
          rail.scrollBy({ left: step * Number(b.dataset.railDir), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () { syncRail(rail); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { syncRail(rail); }).observe(rail);
      rail.scrollLeft = 0;
      syncRail(rail);
    });
  }
  initRails();
  window.addEventListener('load', function () {
    document.querySelectorAll('.pbx-rail[data-rail-name]').forEach(function (rail) {
      rail.scrollLeft = 0;
      syncRail(rail);
    });
    pbxInitWishlist(document);
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.pbx-rail[data-rail-name]').forEach(syncRail);
  });
  document.addEventListener('DOMContentLoaded', function () { pbxInitWishlist(document); });
  pbxInitWishlist(document);

  /* Re-bind wishlist buttons whenever new cards are injected. The only place this
     happens after initial render is Dawn's native <product-recommendations>
     custom element, which replaces its own innerHTML once its background fetch
     resolves (see the longer note further down about that same replace-in-place
     behavior on <variant-selects>) — so the observer is scoped to just those
     elements rather than the whole document. */
  if ('MutationObserver' in window) {
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      new MutationObserver(function () { pbxInitWishlist(el); }).observe(el, { childList: true, subtree: true });
    });
  }

  /* ---------------- delegated clicks: sizepills, gender filter/jump ---------------- */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.pbx-sizepill');
    if (pill && !pill.disabled) {
      var pcard = pill.closest('.pbx-pcard');
      pcard.querySelectorAll('.pbx-sizepill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var variantInput = pcard.querySelector('.pbx-variant-id');
      var priceEl = pcard.querySelector('.pbx-price');
      if (variantInput) variantInput.value = pill.dataset.variantId;
      if (priceEl) priceEl.textContent = pill.dataset.priceHtml;
      return;
    }

    var filterBtn = e.target.closest('[data-gender-filter]');
    if (filterBtn) {
      var wrap = filterBtn.closest('.pbx-rail-section');
      wrap.querySelectorAll('[data-gender-filter]').forEach(function (b) { b.classList.remove('is-active'); });
      filterBtn.classList.add('is-active');
      var gender = filterBtn.dataset.genderFilter;
      wrap.querySelectorAll('.pbx-pcard').forEach(function (c) {
        c.hidden = gender !== 'all' && c.dataset.gender !== gender;
      });
      var rail = wrap.querySelector('.pbx-rail[data-rail-name]');
      if (rail) syncRail(rail);
      return;
    }
  });

  /* ---------------- nav: solid once the hero is behind us + mobile menu ---------------- */
  var nav = document.getElementById('pbx-nav');
  if (nav) {
    // Only run the hero-driven solid/over toggle when an actual hero sentinel
    // exists on the page (homepage). Pages without a hero (e.g. product pages)
    // have no dark footage under the nav, so they stay solid/readable always.
    var heroEl = document.querySelector('.pbx-hero');
    if (heroEl) {
      (function () {
        function updateNavSolid() {
          var heroBottom = heroEl.offsetHeight;
          var trigger = heroBottom + window.innerHeight * 0.2;
          var solid = window.scrollY > trigger;
          nav.classList.toggle('is-solid', solid);
          nav.classList.toggle('is-over', !solid);
        }
        window.addEventListener('scroll', updateNavSolid, { passive: true });
        window.addEventListener('resize', updateNavSolid);
        updateNavSolid();
      })();
    } else {
      nav.classList.add('is-solid');
      nav.classList.remove('is-over');
    }

    var menuBtn = document.getElementById('pbx-menu-btn');
    var menu = document.getElementById('pbx-mobile-menu');
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', String(open));
        if (open) { nav.classList.add('is-solid'); nav.classList.remove('is-over'); }
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          menu.classList.remove('is-open');
          menuBtn.setAttribute('aria-expanded', 'false');
        });
      });
    }

    var searchBtn = document.getElementById('pbx-search-btn');
    var searchInput = document.getElementById('pbx-search-input');
    if (searchBtn && searchInput) {
      searchBtn.addEventListener('click', function () {
        var open = searchInput.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', String(open));
        if (open) {
          searchInput.focus();
        } else {
          searchInput.blur();
        }
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          searchInput.classList.remove('is-open');
          searchBtn.setAttribute('aria-expanded', 'false');
          searchInput.blur();
        }
      });
    }
  }

  /* ---------------- scroll reveal ---------------- */
  if (reduce) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('pbx-vis'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.style.transitionDelay = Math.min(i * 60, 240) + 'ms';
        el.classList.add('pbx-vis');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('pbx-vis'); });
  }

  /* ---------------- hero entrance ---------------- */
  if (!reduce && window.gsap) {
    gsap.to('.pbx-hline > span', { y: 0, duration: 1.15, ease: 'power3.out', stagger: 0.09, delay: 0.15 });
    gsap.from('.pbx-hero-cta-wrap', { opacity: 0, y: 14, duration: 0.8, ease: 'power3.out', delay: 0.7 });
  } else {
    document.querySelectorAll('.pbx-hline > span').forEach(function (s) { s.style.transform = 'none'; });
  }

  /* ---------------- history: pinned horizontal pan ----------------
     Motivated: the section is a chronology, time reads left to right
     while the reader scrolls down. Collapses to a vertical stack on
     mobile and under reduced motion. */
  var histSection = document.getElementById('pbx-history');
  if (histSection) {
    if (reduce || !window.gsap || !window.ScrollTrigger) {
      histSection.classList.add('no-pan');
    } else {
      gsap.registerPlugin(ScrollTrigger);
      var mm = gsap.matchMedia();
      mm.add('(min-width: 768px)', function () {
        var track = document.getElementById('pbx-hist-track');
        if (!track) return;
        var distance = function () { return track.scrollWidth - window.innerWidth + 80; };
        var tween = gsap.to(track, {
          x: function () { return -distance(); },
          ease: 'none',
          scrollTrigger: {
            trigger: histSection,
            start: 'top top',
            end: function () { return '+=' + distance(); },
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
        return function () { tween.scrollTrigger && tween.scrollTrigger.kill(); };
      });
    }
  }

  /* ---------------- product page: inject per-variant price + savings badge into the stacked picker ----------------
     Dawn's native "button" variant picker only shows the option value text (e.g. the size),
     never a price. The user wants price shown ONLY inside each variant container, plus a green
     "-xx%" badge showing the per-ml saving versus the cheapest (smallest) variant, so this reads
     the {value, price, cents} JSON that main-product.liquid embeds next to the picker (only when
     the product has a single option, so there's no ambiguity about which option determines price)
     and appends name/price/savings spans into each label — wrapping the label's existing text
     (and its sold-out visually-hidden span) into its own span first so CSS can lay out name/price
     independently.
     Dawn's <variant-selects> REPLACES ITSELF ENTIRELY (a whole new element, not just its innerHTML)
     on every selection change, fetched fresh from the section-rendering endpoint. That means: (a)
     any reference to the old <variant-selects> node goes stale the instant a variant is picked, so
     the price lookup always re-queries it fresh by id rather than closing over a cached reference,
     and (b) a MutationObserver attached to the variant-selects node itself stops firing once that
     node is detached. So the observer instead watches the surrounding, ALWAYS-stable
     #ProductInfo-{id} section (this script's own sibling <script> tag lives there too, confirmed
     to survive every re-render), and re-runs the injection on any mutation within it.

     Savings % is computed as: for each variant, price-per-unit = cents / size_in_ml (parsed from
     the leading number in the option value, e.g. "2ML" -> 2, "1ML" -> 1). The baseline is always
     the SMALLEST-volume variant (matching the user's literal spec: "how much you save on 1ml
     picking larger size") — NOT whichever variant happens to have the lowest per-ml price. Real
     catalogue data doesn't always scale monotonically (e.g. 1/2/5/10/20/30ml priced at
     14.40/25.70/51.90/94.60/185.90/282.90 zł has its cheapest per-ml rate at 20ml, not 1ml), so
     picking the global per-ml minimum as "baseline" would show a bogus negative-looking badge on
     the smallest size and no badge at all on the actual best-value size — confirmed exactly that
     way on the live product page before this fix. Every variant LARGER than the smallest shows how
     much cheaper its own per-ml price is versus the smallest size; the smallest itself shows no
     badge; a variant that's somehow more expensive per-ml than the smallest also shows no badge
     (savePct <= 0). Sizes that don't parse (no leading number+ML) are skipped for the calculation
     but still get a price. */
  function pbxParseMl(value) {
    var m = /^(\d+(?:[.,]\d+)?)\s*ML/i.exec(String(value).trim());
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }
  function pbxInjectVariantPrices(scriptEl, sectionId) {
    var variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (!variantSelects) return;
    var data;
    try { data = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    var priceByValue = {};
    data.forEach(function (v) { priceByValue[v.value] = v; });

    // smallest-volume variant among all that parse as a size, for the savings baseline
    var perUnit = data
      .map(function (v) { var ml = pbxParseMl(v.value); return ml ? { value: v.value, ml: ml, perMl: v.cents / ml } : null; })
      .filter(Boolean);
    var smallest = perUnit.length ? perUnit.reduce(function (a, b) { return b.ml < a.ml ? b : a; }) : null;
    var baselinePerMl = smallest ? smallest.perMl : null;

    variantSelects.querySelectorAll('fieldset.product-form__input--pill label').forEach(function (label) {
      if (label.querySelector('.pbx-variant-price')) return;
      var input = document.getElementById(label.getAttribute('for'));
      if (!input) return;
      var v = priceByValue[input.value];
      if (!v) return;

      var nameSpan = document.createElement('span');
      nameSpan.className = 'pbx-variant-name';
      while (label.firstChild) nameSpan.appendChild(label.firstChild);

      var priceWrap = document.createElement('span');
      priceWrap.className = 'pbx-variant-price-wrap';

      if (baselinePerMl) {
        var ml = pbxParseMl(input.value);
        if (ml) {
          var perMl = v.cents / ml;
          var savePct = Math.round((1 - perMl / baselinePerMl) * 100);
          if (savePct > 0) {
            var saveSpan = document.createElement('span');
            saveSpan.className = 'pbx-variant-save';
            saveSpan.textContent = '-' + savePct + '%';
            priceWrap.appendChild(saveSpan);
          }
        }
      }

      var priceSpan = document.createElement('span');
      priceSpan.className = 'pbx-variant-price';
      priceSpan.textContent = v.price;
      priceWrap.appendChild(priceSpan);

      label.appendChild(nameSpan);
      label.appendChild(priceWrap);
    });
  }
  document.querySelectorAll('.pbx-product-page script.pbx-variant-prices').forEach(function (scriptEl) {
    var sectionId = scriptEl.dataset.section;
    if (!document.getElementById('variant-selects-' + sectionId)) return;
    var observeRoot = document.getElementById('ProductInfo-' + sectionId) || scriptEl.parentElement;
    pbxInjectVariantPrices(scriptEl, sectionId);
    var observer = new MutationObserver(function () {
      pbxInjectVariantPrices(scriptEl, sectionId);
    });
    observer.observe(observeRoot, { childList: true, subtree: true });
  });

  /* ---------------- homepage trust widget: show only 3 cards until "Pokaż więcej" ---------------- */
  var trustGrid = document.querySelector('.pbx-trust-grid');
  if (trustGrid && trustGrid.children.length > 3) {
    trustGrid.classList.add('pbx-trust-collapsed');
    var trustBtn = document.createElement('button');
    trustBtn.type = 'button';
    trustBtn.className = 'pbx-trust-showmore';
    trustBtn.textContent = 'Pokaż więcej';
    trustBtn.addEventListener('click', function () {
      trustGrid.classList.remove('pbx-trust-collapsed');
      trustBtn.hidden = true;
    });
    trustGrid.insertAdjacentElement('afterend', trustBtn);
  }
})();
